import "./password-setup.scss";
import { useParams } from "react-router";
import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import api from "api";
import { ContactType } from "types";
import { useHistory } from "react-router-dom";

function PasswordSetup() {
    const history = useHistory();
    const params: any = useParams();
    const [loading, setLoading] = useState<boolean>(false);
    const [contact, setContact] = useState<ContactType | null>(null);
    const [password, setPassword] = useState<string>("");
    const [passwordConfirm, setPasswordConfirm] = useState<string>("");
    const [error, setError] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const resetPassword = async () => {
        console.log(params.contactId);
        if (password !== passwordConfirm) {
            setErrorMessage("Passwords do not match");
            return;
        }

        setLoading(true);

        const data = await api.contact.setPassword(params.contactId, password);
        console.log(data);

        if (data.status == 200) {
            toast.success("Password set successfully");
            setTimeout(() => {
                window.location.replace(process.env.PUBLIC_URL + "/login");
            }, 3000);
        } else {
            toast.success("Error occurred setting password");
        }

        setLoading(false);
    };

    return (
        <div className="password-setup">
            <div>
                <img src="/img/logo-full.svg" alt="amaSocial Logo" />
            </div>
            <div>
                <h2>PASSWORD SETUP</h2>
                {error ? (
                    <p>The user could not be found for the ID specified</p>
                ) : (
                    <>
                        <input
                            type="password"
                            placeholder="Password"
                            onChange={(e: any) => setPassword(e.target.value)}
                            readOnly
                            onFocus={(e) => e.target.removeAttribute("readonly")}
                            onKeyUp={(e) => (e.key === "Enter" ? resetPassword() : null)}
                        />
                        <input
                            type="password"
                            placeholder="Confirm Password"
                            onChange={(e: any) => setPasswordConfirm(e.target.value)}
                            readOnly
                            onFocus={(e) => e.target.removeAttribute("readonly")}
                            onKeyUp={(e) => (e.key === "Enter" ? resetPassword() : null)}
                        />
                        {errorMessage && <p className="error-message">Passwords do not match</p>}
                        <button onClick={resetPassword} disabled={!password.length || !passwordConfirm.length}>
                            {!loading ? "CONFIRM" : <i className="fal fa-spinner fa-spin"></i>}
                        </button>
                    </>
                )}
            </div>
        </div>
    );
}

export default PasswordSetup;
